"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _commander = require("commander");
const _index = require("./commands/run/index.js");
const _index1 = require("./commands/cache/index.js");
const _errors = require("./types/errors.js");
const _index2 = require("./commands/affected/index.js");
const _index3 = require("./commands/init/index.js");
const _index4 = require("./commands/info/index.js");
const _index5 = require("./commands/exec/index.js");
async function main() {
    const program = new _commander.Command();
    program.addCommand(_index.runCommand, {
        isDefault: true
    });
    program.addCommand(_index1.cacheCommand);
    program.addCommand(_index2.affectedCommand);
    program.addCommand(_index3.initCommand);
    program.addCommand(_index4.infoCommand);
    program.addCommand(_index5.execCommand);
    await program.parseAsync(process.argv);
}
main().catch((err)=>{
    /* eslint-disable no-console */ switch(err){
        case _errors.NoTargetFoundError:
            console.log("lage: no targets found that matches the given scope.");
            break;
        default:
            console.error(err);
            break;
    }
    /* eslint-enable no-console */ process.exitCode = 1;
});
